import '~/assets/css/tailwind.css'
import 'simplebar-react/dist/simplebar.min.css'

import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App.tsx'

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN as string,
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
